import { render } from "./GoToConnectFlow.vue?vue&type=template&id=54d1e596&ts=true"
import script from "./GoToConnectFlow.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoToConnectFlow.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/GoToConnectFlow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54d1e596"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54d1e596', __exports__)) {
    api.reload('54d1e596', __exports__)
  }
  
  module.hot.accept("./GoToConnectFlow.vue?vue&type=template&id=54d1e596&ts=true", () => {
    api.rerender('54d1e596', render)
  })

}


export default __exports__